const {
    mapLineItemFromSalesOrderItems,
    mapShippingFromSalesOrderDetailShipping,
    mapAdrFromSalesOrderDetail,
    mapOrderTotalsFromSalesOrderDetail,
    mapPaymentsFromSalesOrder,
    getValueFromSalesOrderCustom
} = require('./mappings');

const fromSalesOrderRequest = (salesOrderRequest) => {
    if (salesOrderRequest == null) {
        return null;
    }

    const eventCode = getValueFromSalesOrderCustom(salesOrderRequest.Custom, 'CODE', 'EVENT'),
        sender = getValueFromSalesOrderCustom(salesOrderRequest.Custom, 'SENDER'),
        shippingPayWithPoints = getValueFromSalesOrderCustom(salesOrderRequest.Custom, 'ZZUSE_PTS'),
        microsite = getValueFromSalesOrderCustom(salesOrderRequest.Custom, 'REASON', 'REASON');

    return {
        orderId: salesOrderRequest.ID,
        action: salesOrderRequest.OrderAction,
        reason: salesOrderRequest.Reason,
        category: salesOrderRequest.Category,
        externalId: salesOrderRequest.ExternalID,
        countryCode: salesOrderRequest.CountryCode,
        productDiscountCode: salesOrderRequest.ProductDiscountCode,
        shippingDiscountCode: salesOrderRequest.ShippingDiscountCode,
        soldToMemberId: salesOrderRequest.SoldToMemberID,
        pricing: salesOrderRequest.Pricing,
        lineItems: mapLineItemFromSalesOrderItems(
            salesOrderRequest.Item),
        shipping: mapShippingFromSalesOrderDetailShipping(
            salesOrderRequest.Shipping),
        adr: mapAdrFromSalesOrderDetail(salesOrderRequest),
        orderTotals: mapOrderTotalsFromSalesOrderDetail(salesOrderRequest.OrderTotals),
        payments: mapPaymentsFromSalesOrder(
            salesOrderRequest.Payment),
        // Custom fields
        ...(sender && {sender}),
        ...(eventCode && {eventCode}),
        ...(sender && {sender}),
        ...(shippingPayWithPoints && {shippingPayWithPoints}),
        ...(microsite && {microsite})
    };
};

module.exports = fromSalesOrderRequest;
